import "./i18n";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import LandingPage from "./pages/LandingPage";
import DiagnosticPage from "./pages/DiagnosticPage";
import ResultsPage from "./pages/ResultsPage";
import ExercisesPage from "./pages/ExercisesPage";
import PremiumPage from "./pages/PremiumPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCancelPage from "./pages/PaymentCancelPage";
import HistoryPage from "./pages/HistoryPage";
// Émergence 🌱
import EmergenceLanding from "./pages/EmergenceLanding";
import EmergenceDiagnostic from "./pages/EmergenceDiagnostic";
import EmergenceResults from "./pages/EmergenceResults";
import EmergenceChat from "./pages/EmergenceChat";
import EmergenceJournal from "./pages/EmergenceJournal";
import EmergenceParcours from "./pages/EmergenceParcours";
import EmergenceParcoursDay from "./pages/EmergenceParcoursDay";
import EmergencePaymentSuccess from "./pages/EmergencePaymentSuccess";
import EmergencePaymentCancel from "./pages/EmergencePaymentCancel";
// Séparation 💔
import SeparationDiagnostic from "./pages/SeparationDiagnostic";
import SeparationResults from "./pages/SeparationResults";
// Consultation
import ConsultationCheckout from "./pages/ConsultationCheckout";
import ConsultationSuccess from "./pages/ConsultationSuccess";
import ConsultationCancel from "./pages/ConsultationCancel";
import { Toaster } from "./components/ui/sonner";
import { FloatingContact } from "./components/FloatingContact";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    // Register Service Worker for PWA
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
          .then(reg => console.log('SW registered'))
          .catch(err => console.log('SW registration failed'));
      });
    }
  }, []);

  return (
    <AuthProvider>
      <div className="App min-h-screen bg-[#FAF9F6]">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/diagnostic" element={<DiagnosticPage />} />
            <Route path="/results/:sessionId" element={<ResultsPage />} />
            <Route path="/exercises" element={<ExercisesPage />} />
            <Route path="/premium" element={<PremiumPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/cancel" element={<PaymentCancelPage />} />
            <Route path="/history" element={<HistoryPage />} />
            {/* Émergence 🌱 */}
            <Route path="/emergence" element={<EmergenceLanding />} />
            <Route path="/emergence/diagnostic" element={<EmergenceDiagnostic />} />
            <Route path="/emergence/results/:sessionId" element={<EmergenceResults />} />
            <Route path="/emergence/chat" element={<EmergenceChat />} />
            <Route path="/emergence/journal" element={<EmergenceJournal />} />
            <Route path="/emergence/parcours" element={<EmergenceParcours />} />
            <Route path="/emergence/parcours/:parcoursId/day/:dayNum" element={<EmergenceParcoursDay />} />
            <Route path="/emergence/payment/success" element={<EmergencePaymentSuccess />} />
            <Route path="/emergence/payment/cancel" element={<EmergencePaymentCancel />} />
            {/* Séparation 💔 */}
            <Route path="/separation/diagnostic" element={<SeparationDiagnostic />} />
            <Route path="/separation/results/:sessionId" element={<SeparationResults />} />
            {/* Consultation */}
            <Route path="/consultation/checkout" element={<ConsultationCheckout />} />
            <Route path="/consultation/success" element={<ConsultationSuccess />} />
            <Route path="/consultation/cancel" element={<ConsultationCancel />} />
          </Routes>
          <FloatingContact />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
